import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';

// Realtime may import keys, never the lazy SDK/mutation implementation.
export const openConversationChannelsKey = (scope = sessionScope(useAuthStore.getState())) => ['open-conversation-channels', scope] as const;
export const isConversationOpenId = (value: unknown): value is string => typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value) && value !== '00000000-0000-0000-0000-000000000000';
